import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['mainInput', 'filterInput', 'filterInputBlock'];

  handleInputs(e) {
    const blockToShow = this.filterInputBlockTargets.find(b => {
      const input = b.querySelector('[data-dynamic-screen-filters-target="filterInput"]');
      this.mainInputTarget.value = input.value
      return input.name === e.target.value;
    });

    this.filterInputBlockTargets.map(b => { blockToShow == b ? b.classList.remove('hidden') : b.classList.add('hidden') });
  }

  setMainInputValue(e) {
    this.mainInputTarget.value = e.target.value;
  }
}